// Dashboard — quick at-a-glance: tenant + plan, counts of
// podcasts/projects/active jobs. No charts, no live data feeds — that
// lands once specific user stories show up.

import { useMe, usePodcasts, useProjects, useJobs } from '../lib/queries';

interface StatCardProps {
  label: string;
  value: string | number;
  hint?: string;
}

function StatCard({ label, value, hint }: StatCardProps) {
  return (
    <div className="bg-surface border border-border rounded-lg p-4">
      <div className="text-xs uppercase tracking-wider text-muted">{label}</div>
      <div className="text-3xl font-semibold mt-2">{value}</div>
      {hint && <div className="text-xs text-muted mt-1">{hint}</div>}
    </div>
  );
}

export function DashboardPage() {
  const me = useMe();
  const podcasts = usePodcasts();
  const projects = useProjects();
  const jobs = useJobs();

  const activeJobs = (jobs.data?.jobs ?? []).filter(
    (j) => j.status === 'pending' || j.status === 'active',
  ).length;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold">Dashboard</h1>
        <p className="text-muted text-sm mt-1">
          Tenant <span className="text-text">{me.data?.tenant ?? '—'}</span>
          {' · '}
          Plan <span className="text-text">{me.data?.plan_slug ?? '—'}</span>
        </p>
      </header>
      <section className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <StatCard
          label="Podcasts"
          value={podcasts.data?.total ?? podcasts.data?.podcasts.length ?? '—'}
        />
        <StatCard
          label="Projects"
          value={projects.data?.total ?? projects.data?.projects.length ?? '—'}
        />
        <StatCard
          label="Active jobs"
          value={activeJobs}
          hint={`${jobs.data?.jobs.length ?? 0} total`}
        />
        <StatCard
          label="Status"
          value={me.isError ? 'down' : 'ok'}
        />
      </section>
    </div>
  );
}
